import styled from 'styled-components';

export const TooltipContent = styled.div`
    border-radius: 0.25rem;
    background: var(--colorFontsCardsDashboard);
    color: var(--colorBackgroundCardsDashboard);
    padding: 1rem;
    box-shadow: 15px 30px 40px 5px rgba(0, 0, 0, 0.5);
    text-align: center;

    h4{
        margin-bottom: 0.5rem;
    }

    p{
        font-size: 0.9rem;
    }
`
